import type { MouseEvent, ReactNode } from 'react';
import styles from './ActionLink.module.css';

interface ActionLinkProps {
  href?: string;
  onClick?: (e: MouseEvent) => void;
  danger?: boolean;
  disabled?: boolean;
  title?: string;
  children: ReactNode;
}

export function ActionLink({
  href,
  onClick,
  danger = false,
  disabled = false,
  title,
  children,
}: ActionLinkProps) {
  const cls = [styles.actionLink, danger ? styles.danger : '', disabled ? styles.disabled : '']
    .filter(Boolean)
    .join(' ');

  return (
    <a
      className={cls}
      href={disabled ? undefined : href}
      onClick={disabled ? undefined : onClick}
      title={title}
      aria-disabled={disabled || undefined}
      role={href ? undefined : 'button'}
    >
      {children}
    </a>
  );
}
